var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstetoscopio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50887 17.6963V19.6818C9.47655 20.6586 9.64103 21.6319 9.99253 22.5439C10.344 23.4559 10.8754 24.2878 11.555 24.9902C12.2345 25.6927 13.0485 26.2512 13.9483 26.6327C14.8481 27.0142 15.8155 27.2108 16.7929 27.2108C17.7702 27.2108 18.7376 27.0142 19.6375 26.6327C20.5373 26.2512 21.3512 25.6927 22.0308 24.9902C22.7104 24.2878 23.2417 23.4559 23.5932 22.5439C23.9447 21.6319 24.1092 20.6586 24.0769 19.6818V17.6963",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 14.3154C20.6625 14.9907 20.8613 15.6514 21.2353 16.2136C21.6094 16.7759 22.1418 17.2146 22.7653 17.4741C23.3887 17.7336 24.0752 17.8023 24.7377 17.6716C25.4003 17.5408 26.0091 17.2164 26.4872 16.7394C26.9653 16.2624 27.2911 15.6544 27.4234 14.9921C27.5558 14.3299 27.4886 13.6433 27.2306 13.0192C26.9725 12.3952 26.5351 11.8617 25.9737 11.4863C25.4123 11.111 24.7522 10.9106 24.0768 10.9106C23.1731 10.9106 22.3062 11.2691 21.6665 11.9074C21.0267 12.5457 20.6662 13.4117 20.6641 14.3154V14.3154Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50804 17.6965C7.55961 17.6965 5.69086 16.923 4.31236 15.546C2.93386 14.169 2.15836 12.3011 2.15625 10.3526V6.19036C2.15625 5.41001 2.46624 4.66161 3.01803 4.10982C3.56982 3.55803 4.31821 3.24805 5.09856 3.24805H5.95175",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95996 2.02783V4.53956",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50879 17.6965C11.4558 17.6944 13.3225 16.92 14.6993 15.5432C16.0761 14.1664 16.8505 12.2997 16.8526 10.3526V6.19036C16.8526 5.41001 16.5426 4.66161 15.9908 4.10982C15.439 3.55803 14.6906 3.24805 13.9103 3.24805H13.0491",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0566 2.02783V4.53956",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstetoscopio);
export default __webpack_public_path__ + "static/media/estetoscopio.03f5e842a1c0da1cbb7d059a235ec015.svg";
export { ForwardRef as ReactComponent };